import axionIns from "../axios";

const getSettings = async () => {
  return axionIns.get("admin/settings").then((response) => {return response.data});
};

const updateSettings = async (payload) => {
  return axionIns.put("admin/settings", JSON.stringify(payload)).then((response) => {return response.data});
};

const getAIToggle = async () => {
  return axionIns.get("admin/ai-toggle").then((response) => {return response.data});
};

const updateAIToggle = async (payload) => {
  return axionIns.post("admin/ai-toggle", JSON.stringify(payload)).then((response) => {return response.data});
};

const getAppleLoginToggle = async () => {
  return axionIns.get("admin/apple-login-toggle").then((response) => {return response.data});
};

const updateAppleLoginToggle = async (payload) => {
  return axionIns.post("admin/apple-login-toggle", JSON.stringify(payload)).then((response) => {return response.data});
};

const exportOject = {
  getSettings,
  updateSettings,
  getAIToggle,
  updateAIToggle,
  getAppleLoginToggle,
  updateAppleLoginToggle
};

export default exportOject;
